
import React from 'react';
import { roleLabels } from './user-list/mockData';
import { useUserManagement } from './user-list/useUserManagement';
import UserListHeader from './user-list/UserListHeader';
import UserTable from './user-list/UserTable';
import AddUserDialog from './user-list/AddUserDialog';
import EditUserDialog from './user-list/EditUserDialog';
import DeleteUserDialog from './user-list/DeleteUserDialog';

interface UsersListProps {
  editing: boolean;
}

const UsersList: React.FC<UsersListProps> = ({ editing }) => {
  const {
    users,
    searchTerm,
    setSearchTerm,
    newUserDialogOpen,
    setNewUserDialogOpen,
    editUserDialogOpen,
    setEditUserDialogOpen,
    deleteDialogOpen,
    setDeleteDialogOpen,
    currentUser,
    setCurrentUser,
    newUser,
    setNewUser,
    handleAddUser,
    handleEditUser,
    handleDeleteUser,
    openEditDialog,
    openDeleteDialog
  } = useUserManagement();

  return (
    <div className="space-y-4">
      <UserListHeader 
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        openAddUserDialog={() => setNewUserDialogOpen(true)}
        editing={editing}
      />

      <AddUserDialog 
        open={newUserDialogOpen}
        onOpenChange={setNewUserDialogOpen}
        newUser={newUser}
        setNewUser={setNewUser}
        onAddUser={handleAddUser}
      />

      <EditUserDialog 
        open={editUserDialogOpen}
        onOpenChange={setEditUserDialogOpen}
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        onEditUser={handleEditUser}
      />

      <DeleteUserDialog 
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        currentUser={currentUser}
        onDeleteUser={handleDeleteUser}
      />

      <UserTable 
        users={users}
        editing={editing}
        onEditUser={openEditDialog}
        onDeleteUser={openDeleteDialog}
        roleLabels={roleLabels}
      />
    </div>
  );
};

export default UsersList;
